export default {"src":"/_next/static/media/clock.f365e44e.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};